import React from "react";
import { Input } from "./Controls";

export function DateRange({ from, to, onChange }: { from: string; to: string; onChange: (from: string, to: string) => void }) {
  return (
    <div className="flex items-center gap-2">
      <Input type="date" value={from} max={to || undefined} onChange={(e) => onChange(e.target.value, to)} className="w-full sm:w-40" data-testid="date-range-from" aria-label="Desde" />
      <span className="text-slate-400">–</span>
      <Input type="date" value={to} min={from || undefined} onChange={(e) => onChange(from, e.target.value)} className="w-full sm:w-40" data-testid="date-range-to" aria-label="Hasta" />
    </div>
  );
}
